module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n    <my-item-subfamily-consult-delete></my-item-subfamily-consult-delete>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/subfamilia/item-subfamily.component.html
// module id = ./src/app/subfamilia/item-subfamily.component.html
// module chunks = main